<template>
  <el-container>
    <el-main style='height:100vh;padding:0px'>
      <div  class='div-form'>
      <el-form :label-position='labelPosition' :model='formUaccount' :rules='rules' label-width='80px'  size='mini'  ref='formUaccount'>
<!--        <el-form-item label='公司名字'  prop ='companyname'>-->
<!--          <el-col :span='10'>-->
<!--          <el-input v-model='formUaccount.companyname' ></el-input>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
        <el-form-item label='公司名称'  prop ='companyname'>
        <el-col :span='10'>
          <el-autocomplete
            class='inline-input'
            v-model='formUaccount.companyname'
            :fetch-suggestions='querySearch'
            placeholder='请输入内容'
            @select='handleSelect'
            style='width:100%'
          ></el-autocomplete>
        </el-col>
        </el-form-item>
        <el-form-item label='用户名'  prop ='account'>
          <el-col :span='10'>
          <el-input v-model='formUaccount.account' @change="validate" :disabled="disableflag"></el-input>
          </el-col>
          <el-col :span='5'>
            <span>{{message}}</span>
          </el-col>
        </el-form-item>
<!--        <el-form-item label='密码'  prop ='password'>-->
<!--          <el-col :span='10'>-->
<!--          <el-input v-model='formUaccount.password' ></el-input>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
        <el-form-item label='角色'  prop='role'>
          <el-col :span='10'>
        <el-select v-model='formUaccount.role'  style='width:100%'  placeholder='请选择角色类型'>
           <el-option v-for='item in roles'
          :key='item.value'
          :label='item.label'
          :value='item.label'>
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label='手机号'  prop ='phonenumber'>
          <el-col :span='10'>
            <el-input v-model='formUaccount.phonenumber' @change="validatePhone" ></el-input>
          </el-col>
          <el-col :span='5'>
            <span>{{this.phonemessage}}</span>
          </el-col>
        </el-form-item>

        <el-form-item label='账号类型'  prop='accounttype'>
          <el-col :span='10'>
            <el-select v-model='formUaccount.accounttype'  style='width:100%'  placeholder='请选择设备类型'>
              <el-option label="拓疆智载" value="2"></el-option>
              <el-option label="清洗喷枪" value="1"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

<!--        <el-form-item label="账号类型" prop="accounttype">-->
<!--          <el-col :span='10'>-->
<!--          <el-select   v-model="formUaccount.accounttype" placeholder="请选择设备类型" >-->
<!--            <el-option label="消防吊桶" value="2"></el-option>-->
<!--            <el-option label="清洗喷枪" value="1"></el-option>-->
<!--          </el-select>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
        <el-form-item label='备注'  prop ='realname'>
          <el-col :span='10'>
            <el-input v-model='formUaccount.realname' ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label='是否测试账号'>
          <el-col :span='10'>
            <el-checkbox v-model='formUaccount.testAccount'>测试账号</el-checkbox>
          </el-col>
        </el-form-item>
<!--        <el-form-item label='用户类型'  prop ='accounttype'>-->
<!--          <el-col :span='10'>-->
<!--            <el-input v-model='formUaccount.accounttype' ></el-input>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-col :span='10'>
          <el-button type='primary' @click='save(formUaccount)' >保存</el-button>
          <el-button plain @click='reset'>重置</el-button>
          <el-button plain @click='closed'>返回</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import axios from '../../../utils/request'

export default {
  data () {
    return {
      state: 0,
      companynames: [],
      formUaccount: {
        companyname: '',
        account: '',
        // password: '',
        phonenumber: '',
        realname: '',
        accounttype: '',
        userId: 1,
        role: '',
        testAccount: false
      },
      rules: {
        companyname: [
          { required: true, message: '请填公司名称', trigger: 'change' }
        ],
        account: [
          { required: true, message: '请填账户名', trigger: 'change' }
        ],
        // password: [
        //   { required: true, message: '请填密码', trigger: 'change' }
        // ],
        // phonenumber: [
        //   { required: true, message: '请填手机', trigger: 'change' }
        // ],
        // realname: [
        //   { required: true, message: '请填名字', trigger: 'change' }
        // ],
        accounttype: [
          { required: true, message: '请填账户类型', trigger: 'change' }
        ],
        role: [
          { required: true, message: '请填角色类型', trigger: 'change' }
        ]
      },
      roles: [{label: '超级管理员', value: 0}, {label: '普通管理员', value: 1}],
      message: '',
      phonemessage: '',
      disableflag: false
    }
  },
  mounted () {
    this.loading()
  },
  methods: {
    toBool: function (str) {
      return str.toLowerCase() === 'true'
    },
    save: function (formUaccount) {
      this.loading1 = true
      console.log(this.$refs.formUaccount)
      console.log(1111)
      this.$refs.formUaccount.validate((valid) => {
        if (valid) {
          console.log(valid)
          let params = this.formUaccount
          if (params.requesttype === 'update') {
            // this.$delete(params, 'requesttype')
            console.log(params)
            axios.put('/data/account/update', params).then(res => {
              console.log('success')
              this.disableflag = false
              this.closed()
            })
          } else {
            if (this.state === 1) {
              axios.post('/data/account/insert', params).then(res => {
                console.log('success')
                this.state = 0
                this.closed()
              })
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset: function () {
      this.formUaccount.companyname = ''
      if (this.disableflag === false) {
        this.formUaccount.account = ''
      }
      // this.formUaccount.password = ''
      this.formUaccount.phonenumber = ''
      this.formUaccount.realname = ''
      this.formUaccount.accounttype = ''
      this.formUaccount.role = ''
      this.formUaccount.testAccount = false
    },
    closed: function () {
      this.$router.push('/data/useraccount')
    },
    querySearch (queryString, cb) {
      var companynames = this.companynames
      var results = queryString ? companynames.filter(this.createFilter(queryString)) : companynames
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return (company) => {
        return (company.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    loading: function () {
      console.log(this.$route)
      this.formUaccount.companyname = this.$route.query.companyname
      this.formUaccount.account = this.$route.query.account
      // this.formUaccount.password = this.$route.query.password
      this.formUaccount.phonenumber = this.$route.query.phonenumber
      this.formUaccount.realname = this.$route.query.realname
      this.formUaccount.accounttype = this.$route.query.accounttype
      this.formUaccount.id = this.$route.query.id
      this.formUaccount.role = this.$route.query.role
      this.formUaccount.requesttype = this.$route.query.requesttype
      this.formUaccount.testAccount = this.$route.query.testAccount === 'true'
      this.disableflag = this.toBool(this.$route.query.disableflag)
      axios.get('/data/account/getCompanyname').then(res => {
        this.companynames = res.data
        console.log('this.companynames', this.companynames)
      })
    },
    handleSelect (item) {
      console.log(item)
    },
    validate (val) {
      axios.get(`/data/account/validate?account=${val}`).then(res => {
        console.log('message', res)
        this.message = res.data
        if (this.message === '该用户名可用') {
          this.state = 1
        }
      })
    },
    validatePhone (val) {
      axios.get(`/data/account/validatephone?phone=${val}`).then(res => {
        console.log('message', res)
        this.phonemessage = res.data
      })
    }
  }
}
</script>

<style scoped>
  .el-container {
    height: 100%;
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .div-form{
    margin-top: 100px;
    margin-left: 280px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/account/adduseraccount.vue